/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CurrencyExchangeConfigurationListSortCriteria {
    getFixupPrototypeFunction() { return CurrencyExchangeConfigurationListSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<CurrencyExchangeConfigurationListSortCriteria>): CurrencyExchangeConfigurationListSortCriteria {
        let obj = Object.assign(new CurrencyExchangeConfigurationListSortCriteria(), model);
        CurrencyExchangeConfigurationListSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CurrencyExchangeConfigurationListSortCriteria>): CurrencyExchangeConfigurationListSortCriteria {
        if (!model) return null;
        return CurrencyExchangeConfigurationListSortCriteria.newInstance(<CurrencyExchangeConfigurationListSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CurrencyExchangeConfigurationListSortCriteria) {
        if (!obj) return;

        models.CurrencyExchangeConfigurationListSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CurrencyExchangeConfigurationListSortCriteria): boolean {
        Object.setPrototypeOf(obj, CurrencyExchangeConfigurationListSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.CurrencyExchangeConfigurationListSortColumn;

    ascending: boolean;

}
